import React, { useState } from "react";
import { observer } from "mobx-react";
import LmtLsEventStore from "@state/stores/side-widgets/LmtLsEventStore";

import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { OfferStoreContext } from "@gp/components";

import { EventList } from ".";

type TEventListTabs = "LMT" | "LS";

export const EventSelectorView = observer(
	(props: { lmtLsStore: LmtLsEventStore }) => {
		const t = useTranslation().t;
		const [tab, setTab] = useState<TEventListTabs>("LMT");

		return (
			<OfferStoreContext.Provider value={props.lmtLsStore}>
				<div className="widget__list__tab">
					<button
						onClick={() => setTab("LMT")}
						className={classNames(
							"tabs--base__item tabs--primary__item",
							{
								"is-active": tab === "LMT",
								"is-disabled":
									props.lmtLsStore.lmtEvents.length <= 0,
							}
						)}
						disabled={props.lmtLsStore.lmtEvents.length <= 0}
					>
						{t("SIDE_WIDGET.LMT_TAB")}
					</button>
					<button
						onClick={() => setTab("LS")}
						className={classNames(
							"tabs--base__item tabs--primary__item",
							{
								"is-active": tab === "LS",
								"is-disabled":
									props.lmtLsStore.lsEvents.length <= 0,
							}
						)}
						disabled={props.lmtLsStore.lsEvents.length <= 0}
					>
						{t("SIDE_WIDGET.LS_TAB")}
					</button>
				</div>
				<EventList lmtLsStore={props.lmtLsStore} tab={tab} />
			</OfferStoreContext.Provider>
		);
	}
);
